import { formatNumbers } from 'core/helpers/format-numbers'

import avatar from './assets/images/avatar.png'

import c from './assets/sass/item.module.scss'

export const Item = ({ nickName, reward, avatarUrl }) => {
    return (
        <li className={c.component}>
            <div className={c.user}>
                <img src={avatarUrl || avatar} alt="User" />
                <span>{nickName}</span>
            </div>
            <span className={c.reward}>{formatNumbers(reward)}</span>
        </li>
    )
}
